var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3106_3095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 42.3799C0 64.4699 17.91 82.3799 40 82.3799C62.09 82.3799 80 64.4699 80 42.3799C80 20.2899 62.09 2.37988 40 2.37988C17.91 2.37988 0 20.2899 0 42.3799Z",
    fill: "#E0E9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 19.05L20.2398 16.75L24.5198 22.62C25.9398 24.56 27.1398 26.66 28.0998 28.86L46.2898 68.91C46.7098 69.76 46.3598 70.78 45.5098 71.2C44.6898 71.6 43.6898 71.29 43.2498 70.48L21.1098 32.43C19.8798 30.4 18.8798 28.23 18.1198 25.97L15.7798 19.04L15.7998 19.05Z",
    fill: "white",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1801 23.5798C24.9601 23.2598 24.7501 22.9398 24.5301 22.6298L20.2501 16.7598L15.8101 19.0598L18.1401 25.9898C18.2601 26.3398 18.3901 26.6898 18.5201 27.0298L25.1801 23.5798Z",
    fill: "#2B6BF3",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2399 16.7502C21.3099 15.3502 21.4299 13.4302 20.5499 11.9002C18.5399 8.02019 14.5999 8.72019 12.8399 4.99019C12.5799 4.43019 11.9199 4.20019 11.3599 4.46019C11.1499 4.56019 10.9699 4.72019 10.8599 4.93019C8.71992 8.79019 9.75992 13.8302 12.2199 16.7602C13.1199 17.9102 14.3799 18.7202 15.7999 19.0602L20.2399 16.7602V16.7502Z",
    fill: "white",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0301 51.7801C53.7501 52.9301 52.5901 53.6301 51.4401 53.3501L39.9801 50.5501C38.8301 50.2701 38.1201 49.1101 38.4101 47.9601L49.6101 2.14007C49.8901 0.990072 51.0501 0.280072 52.2001 0.560072L63.6501 3.36007C64.8001 3.64007 65.5101 4.80007 65.2201 5.95007L54.0201 51.7801H54.0301Z",
    fill: "white",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5898 6.2998L54.8398 7.8298",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0601 12.5498L52.2701 13.8198",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.54 18.7998L51.79 20.3298",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0098 25.0498L49.2198 26.3198",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48 31.29L48.73 32.82",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9502 37.54L46.1602 38.81",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4199 43.79L45.6699 45.32",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6199 22.9201C63.1599 23.9001 61.9899 24.3301 60.9999 23.8701L59.6099 26.8401L65.5499 29.6201L66.9399 26.6501C65.9499 26.2001 65.5099 25.0301 65.9599 24.0401C66.4099 23.0501 67.5799 22.6101 68.5699 23.0601C68.5899 23.0601 68.5999 23.0701 68.6199 23.0801L70.5699 18.9201C68.8999 16.6201 70.3799 11.5801 70.3799 11.5801C70.3799 11.5801 67.4599 15.9401 64.6299 16.1401L62.6799 20.3001C63.6699 20.7601 64.0899 21.9401 63.6299 22.9201H63.6199Z",
    fill: "#2B6BF3",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.71 35.1696L59.6 26.8496L65.54 29.6296L61.65 37.9496L55.71 35.1696Z",
    fill: "white",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37 11.5898L66.75 19.3198",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0698 56.4899C46.6298 57.5499 47.1398 58.7599 48.1998 59.1999C49.1898 59.6099 50.3198 59.1999 50.8198 58.2499L61.6498 37.9499L55.7098 35.1699L47.0698 56.4899Z",
    fill: "#2B6BF3",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3198 19.2598L29.8298 22.4198L38.2898 21.0698L37.7798 17.9098L32.3898 11.3398C32.3898 11.3398 29.3298 19.2598 29.3198 19.2698V19.2598Z",
    fill: "white",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3899 11.3298L32.1499 9.7998",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5299 53.7695L35.0699 55.1195L29.3799 19.6195L31.9899 20.4395L33.6099 18.9395L35.6199 19.8595L37.8399 18.2695L43.5299 53.7695Z",
    fill: "#2B6BF3",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8498 59.9596L36.1398 61.7696C36.4798 64.1096 38.6498 65.7296 40.9898 65.3896C43.3298 65.0496 44.9498 62.8796 44.6098 60.5396C44.6098 60.4996 44.5998 60.4596 44.5898 60.4096L44.2998 58.5996L35.8398 59.9596H35.8498Z",
    fill: "#2B6BF3",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0698 55.1198L43.5298 53.7598L44.2998 58.5898L35.8498 59.9498L35.0698 55.1198Z",
    fill: "white",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91 56.1797L35.46 57.5297",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9902 20.4502L37.4902 54.7402",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6099 19.8701L41.1099 54.1601",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7501 41.4303C63.6201 40.9003 63.1501 40.5303 62.6101 40.5303H20.9701C20.6101 40.5303 10.9601 61.4503 15.9001 61.6503C17.4601 61.7103 19.5901 61.6503 19.5901 61.6503V68.3703C19.5901 71.4303 22.0701 73.9203 25.1401 73.9203H31.8601V81.5603C40.1301 83.2603 48.7001 82.3303 56.4001 78.8903V68.1503C62.7901 63.8403 64.5601 58.8203 64.5601 51.4503C64.5601 48.1003 64.3001 44.7503 63.7701 41.4403L63.7501 41.4303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1201 51.43C26.1201 52.33 26.8501 53.06 27.7501 53.06C28.6501 53.06 29.3801 52.33 29.3801 51.43C29.3801 50.53 28.6501 49.79 27.7501 49.79C26.8501 49.79 26.1201 50.52 26.1201 51.42V51.43Z",
    fill: "#2C2F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3801 78.88V68.14C62.7701 63.83 64.5401 58.81 64.5401 51.44C64.5401 48.09 64.2801 44.75 63.7501 41.44C63.6201 40.91 63.1501 40.54 62.6101 40.54H20.9701C20.6101 40.54 10.9601 61.46 15.9001 61.66C17.4601 61.72 19.5901 61.66 19.5901 61.66V68.38C19.5901 71.44 22.0701 73.93 25.1401 73.93H31.8601V81.57",
    stroke: "#2C2F36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3106_3095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 82.38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.e0a8eca67b2527259658cc33465ab210.svg";
export { ForwardRef as ReactComponent };